// index.tsx

import React from "react";
import ReactDOM from "react-dom/client";
import './globals.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
/*    <React.StrictMode>*/
        <HelmetProvider>
            <App/>
        </HelmetProvider>
    /*   </React.StrictMode>*/
);

// 성능 측정 관련
reportWebVitals();
